// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3RPFP","calendarButtons":"ClockData_calendarButtons__22nYu"};